export default function manager ({ to,from,next, store }) {
  const user = store.state.user;
  if (user && user.type === 'MANAGER') {
    return next();
  } else {
    return next({
      name: 'Forbidden',
      params: { errorCode: 403 },
    });
  }
}
